import React, { useState, useEffect, useMemo, useRef } from "react";
import { Box } from "@mui/material";
import HeavyTable from "../components/table/HeavyTable";
import {
  makeSureIsArray,
  loadData,
} from "../functions/general";
import { getTeamCompetitions } from "../functions/getData";
import { isAdmin, isPartnerOrAssistant } from "../functions/checkrole";
import LoadingBackdrop from "../components/general/LoadingBackdrop";
import NoData from "../components/general/NoData";
import Loader from "../components/general/Loader";
import PageHeader from "../components/ui/PageHeader";
import TableCard from "../components/ui/TableCard";
const competitionHeader = () =>
  [
    { id: "name", label: "Team Competition" },
    { id: "status", label: "Status" },
    { id: "global_registration_date", label: "Global Registration Date" },
    {
      id: "competition_start_date",
      label: isPartnerOrAssistant()
        ? "Country Competition Start"
        : "Competition Start",
    },
    {
      id: "competition_end_date",
      label: isPartnerOrAssistant()
        ? "Country Competition End"
        : "Competition End",
    },
    isAdmin() && { id: "competition_organization", label: "Organization" },
    { id: "format", label: "Format" },
  ].filter(Boolean);
const initialParams = "?limits=10";
export default function TeamCompetitions() {
  document.title = "Team Competition";
  const isMounted = useRef(false);
  const [header, setHeader] = useState(competitionHeader());
  const [competitionTable, setCompetitionTable] = useState();
  const [filterOptions, setFilterOptions] = useState();
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [loadingTable, setLoadingTable] = useState(false);
  const [firstLoaded, setFirstLoaded] = useState(false);
  const [id, setId] = useState("");
  const [selected, setSelected] = useState([]);
  const [selecting, setSelecting] = useState([]);
  const [onDelete, setOnDelete] = useState(false);
  const [onAddPartner, setOnAddPartner] = useState(false);
  const [onUpload, setOnUpload] = useState(false);

  const getData = (params, signal) => {
    setSelected([]);
    setSelecting([]);
    loadData(
      setLoadingTable,
      setFirstLoaded,
      getTeamCompetitions,
      params,
      setCompetitionTable,
      setFilterOptions,
      { title: "team_competition" },
      signal
    );
  };

  const controller = useMemo(() => new AbortController(), []);
  const signal = controller.signal;
  useEffect(() => {
    isMounted.current = true;
    getData(initialParams, signal);
    return () => {
      controller.abort();
      isMounted.current = false;
    };
  }, [controller, signal]);

  console.log(competitionTable);

  return (
    <Box className="wrapperBox simcc-page">
      <LoadingBackdrop loading={loading} />
      <PageHeader title="Team Competitions" />
      <TableCard>
        {loadingTable && <Loader height={400} />}
        {!loadingTable && competitionTable && (
          <HeavyTable
            bare
            headers={header}
            list={{ data: makeSureIsArray(competitionTable) }}
            title="team_competition"
            rowsPerPage={rowsPerPage}
            setOnDelete={setOnDelete}
            fixed={["name"]}
            selecting={selecting}
            setSelecting={setSelecting}
            selected={selected}
            setSelected={setSelected}
            setId={setId}
            setOnAddUser={setOnAddPartner}
            setOnUpload={setOnUpload}
          />
        )}
        {!loadingTable &&
          firstLoaded &&
          competitionTable &&
          !makeSureIsArray(competitionTable).length && <NoData height={400} />}
      </TableCard>
    </Box>
  );
}
